export default __webpack_public_path__ + "static/media/sounds/maze_model_sentence_end.mp3";